<template>
    <div class="tab-pane fade show active" id="tags" role="tabpanel" aria-labelledby="tags-tab">
        <transition name="vue-table-loader">
            <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="product-form-tab">
            <product-lang-toggle @language-change="handleVersionChange"></product-lang-toggle>
            <h3 class="pt-2 mb-2">Tags</h3>
            <div class="d-flex flex-column mt-3">
                <h5>
                    Existing Tags
                </h5>
                <div v-if="tagList.length === 0" class="pl-3">No Tags Assigned</div>
                <div class="tag-cloud">
                    <button v-for="(tag, idx) in tagList" :key="idx" class="tag-item" :class="{'tag-item-editing': isEditingId(idx)}" @click.stop="handleTagClick(idx)">
                        <div class="internal-tag-wrapper">
                            <span class="tag-static">{{ tag.tag_value_en }}<i class="ks-icon fa la-fw fa-minus-circle remove-icon ml-2"></i></span>
                        </div>
                    </button>
                </div>
            </div>
            <div class="d-flex flex-column pt-4" v-if="$parent.permissionAllowed('manage_products') && $parent.permissionAllowed('manage_tags')">
                <h5>
                    Add New Tag
                </h5>
                <div class="d-flex align-items-center">
                    <input v-model="newTag" placeholder="New Tag" class="tag-input mr-1">
                    <button class="btn btn-sm btn-primary ml-2" @click.stop="handleNewTag">Assign New Tag</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import productLangToggle from './product-language-select.vue';
import axios from 'axios';

var base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'product-details-tag-cloud',
    components: {
        'product-lang-toggle': productLangToggle
    },
    mounted() {
        this.loadTags();
    },
    props: {
        generalDetails: Object,
        productDetails: Object
    },
    data() {
        return {
            loading: false,
            editingId: -1,
            resultPage: 0,
            version: this.generalDetails.activeLanguageId,
            newTag: '',
            tagArray: [],
            paginationRaw: {},
        }
    },
    computed: {
        tagList() {
            return this.tagArray;
        }
    },
    methods: {
        isEditingId(id) {
            return this.editingId === id;
        },
        handleTagClick(id) {
            this.removeTagWithId(id);
        },
        handleVersionChange(vers) {
            this.resultPage = 0;
            this.version = vers;
            this.loadTags();
        },
        handlePaginationEvent(newPage) {
            this.resultPage = newPage;
            this.loadTags();
        },
        handleNewTag() {
            if (this.newTag !== '') {
                this.loading = true;
                axios.post(base_url + '/pimapi/products/' + this.productDetails.info.id + '/versions/'+this.version+'/tags', {
                    "value": this.newTag
                })
                .then((response) => {
                    this.loadTags();
                    this.newTag = '';
                })
                .catch((error) => {
                    this.loading = false;
                    console.log('tag data load ERROR!');
                });
            }

        },
        removeTagWithId(id) {
            if (!this.$parent.permissionAllowed('manage_tags')) {
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = "Not enough permission to delete tags.";
                return false;
            }
            this.loading = true;
            this.resultPage = 0;
            axios.delete(base_url + '/pimapi/products/' + this.productDetails.info.id + '/versions/'+this.version+'/tags/'+this.tagArray[id].id)
            .then((response) => {
                this.loadTags();
            })
            .catch((error) => {
                this.loading = false;
                console.log('tag data load ERROR!');
            });
        },
        loadTags() {
            this.loading = true;
            axios.get(base_url + '/pimapi/products/' + this.productDetails.info.id + '/versions/'+this.version+'/tags', {})
            .then((response) => {
                this.loading = false;
                this.tagArray = response.data.data;
                this.paginationRaw = response.data.meta;
            })
            .catch((error) => {
                this.loading = false;
                console.log('tag data load ERROR!');
            });
        }
    }
}
</script>

<style scoped>
    .tag-item {
        margin: 3px 2px;
        display: inline-block;
        background-color: #02A7CD;
        border-radius: 2px;
        border-style: solid;
        border-width: 1px;
        border-color: #02A7CD;
    }
    .tag-input {
        padding: 3px;
    }
    .tag-item-editing {
        background-color: white;
    }
    .internal-tag-wrapper {
        display: flex;
        align-items: center;
        min-height: 25px;
    }
    .tag-static {
        min-width: 45px;
        color: white;
        font-weight: 500;
        font-size: 1em;
        padding: 0 10px;
    }
    .remove-icon {
        color: white;
        font-size: 11px;
        cursor: pointer;
    }

    .tag-cloud {
        display: flex;
        flex-wrap: wrap;
        grid-gap: 0.25rem;
    }
</style>
